/**
 * Resolve the model's picks (which speak in `installName`, the allowlist key) to the catalog
 * entries they refer to, preserving the model's best-first order (#626).
 *
 * Pure and standalone so it is unit-testable without mounting the page: the browser holds its
 * own catalog copy, so a pick whose `installName` is not among the candidates it was given is
 * DROPPED rather than rendered as a broken row. This should be impossible — the server validates
 * every returned name against what it retrieved — but a stale tab is a real possibility, so the
 * drop is a guard, not dead code.
 */

import type { JudgePick } from "./ai-mode";
import type { ResolvedPick } from "../components/AiAnswer";
import type { MarketplaceEntry } from "../types/index";

export function resolvePicks(
  candidates: MarketplaceEntry[],
  picks: JudgePick[],
): ResolvedPick[] {
  const byName = new Map(
    candidates.filter((c) => c.installName).map((c) => [c.installName!, c]),
  );
  return picks.flatMap((p) => {
    const entry = byName.get(p.installName);
    return entry ? [{ entry, why: p.why }] : [];
  });
}
